import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestStatsButtonsClickedGet = {
    path: "/stats/buttonsClicked",
    method: RouteHttpVerb.GET
};
export { locationRestStatsButtonsClickedGet };
